import React, { Component } from "react";
import { observer } from "mobx-react";

import { LoadingIndicator } from "@formant/ui/component/common/LoadingIndicator";

import { organizationStore } from "../../../stores";
import { Help } from "../../common/Help";
import { SettingsPage } from "../SettingsPage";
import { IntegrationsSection } from "./IntegrationsSection";
import { WebhooksSection } from "./WebhooksSection";

@observer
export class Integrations extends Component {
    public render() {
        const organization = organizationStore.authenticated();

        return (
            <SettingsPage
                narrow={true}
                scrollable={true}
                title="Integrations"
                extra={
                    <Help
                        text="An integration is a connection from Formant to a third party application, where certain data and/or alerts will be sent according to what you specify. We support direct integrations with major monitoring tools, as well as webhooks which allow you to transmit, via pub/sub, to any destination you prefer."
                        to="https://docs.formant.io/docs/integrations-overview"
                    />
                }
            >
                <LoadingIndicator visible={!organization} />
                {organization && (
                    <>
                        <IntegrationsSection organization={organization} />
                        <WebhooksSection organization={organization} />
                    </>
                )}
            </SettingsPage>
        );
    }
}
